import { AbstractControl, ValidationErrors, ValidatorFn, FormArray } from '@angular/forms';

export function minSelectedCheckboxes(min = 1): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    if (formArray instanceof FormArray) {
      const totalSelected = formArray.controls
        .map(control => control.value)
        .reduce((prev, next) => (next ? prev + 1 : prev), 0);

      return totalSelected >= min ? null : { required: true };
    }
    return null;
  };
}
